import { makeObservable, observable, action, computed } from 'mobx';

export class MessageStackState {
    messages = [];
    index = null;
    constructor() {
        makeObservable(this, {
            index: observable,
            messages: observable,
            messageShown: computed,
            addMessage: action,
            clearMessages: action,
            nextMessage: action,
        });
    }
    addMessage(message) {
        // Message should be an object with:
        // - 'text'
        // - 'tags' - one of 'info', 'warning', 'success', 'error'.
        // - 'content' is optional component, which replaces the text.
        // - 'autoHide' - duration to auto hide, milliseconds
        let msg = {
            content: message,
            active: true,
        }
        this.messages.unshift(msg);
        this.index = 0;
    }
    clearMessages() {
        this.messages = [];
    }

    nextMessage() {
        if (this.index !== null && this.index > this.messages.length) {
            return;
        }
        this.messages[this.index].active = false;  // close it

        this.index = null;
        this.messages.forEach((value, index) => {
            if (value.active && this.index == null) {
                this.index = index;
            }
        });
    }

    get messageShown() {
        if (this.index !== null && this.index < this.messages.length) {
            return this.messages[this.index].content;
        }
        return null;
    }
}
